'use client';

import { getShareFallbackText } from '@/lib/shareFallbackText';
import { getPageDir, getPageLang } from '@/lib/rtl';
import '@/styles/share-fallback.css';
interface ShareFallbackPageProps {
  language?: string;
  title?: string;
  description?: string;
  onCta?: () => void;
}

export function ShareFallbackPage({
  language = 'en',
  title,
  description,
  onCta,
}: ShareFallbackPageProps) {
  const copy = getShareFallbackText(language);
  const displayTitle = title ?? copy.title;
  const displayDescription = description ?? copy.description;

  const handleCta = () => {
    if (onCta) {
      onCta();
      return;
    }
    window.jumpOutLink?.();
  };

  return (
    <main
      className="share-fallback"
      dir={getPageDir(language)}
      lang={getPageLang(language)}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="/assets/empty.png"
        className="share-fallback__img"
        alt=""
      />
      <h1 className="share-fallback__title">{displayTitle}</h1>
      <p className="share-fallback__desc">{displayDescription}</p>
      <button
        type="button"
        className="share-fallback__cta"
        onClick={handleCta}
      >
        {copy.cta}
      </button>
    </main>
  );
}
